import React, { useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import ThemeSwitcher from '../themes/themeSwitcher/ThemeSwitcher';
import ReactSelectSwitcher from '../themes/ReactSwitcher/ReactSelectSwitcher';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';

const Header: React.FC = () => {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  const activeStyle = {
    border: '2px solid currentColor',
    borderRadius: '8px',
    padding: '0.2rem 0.5rem'
  };

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const navItems = [
    { path: "/", name: "Home" },
    { path: "/academy", name: "Academy and Training" }
  ];

  const handleNavLinkClick = () => {
    setMenuOpen(false);
  };

  const listNavLinks = (className: string) => {
    return (
      <div className={className}>
        {navItems.map((item) => (
          <NavLink
            key={item.name}
            to={item.path}
            className="navigation-link"
            style={location.pathname === item.path ? activeStyle : {}}
            onClick={handleNavLinkClick}
          >
            {item.name}
          </NavLink>
        ))}
      </div>
    );
  };

  return (
    <header className="header" style={{ position: 'relative' }}>
      <div className="left-section">
        <div className="navigation">
          <ReactSelectSwitcher />
        </div>

        {listNavLinks("navigation")}

        <div className="menu-dropdown">
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              width: '100%'
            }}
          >
            <img
              src="/me4.png"
              alt="Mohamed Ibrahim"
              style={{
                height: '72px',
                width: '72px',
                objectFit: 'cover',
                borderRadius: '50%'
              }}
            />

            <div style={{ marginLeft: 'auto', paddingRight: '6px' }}>
              <IconButton
                className="custom-icon-button"
                size="large"
                edge="start"
                color="inherit"
                aria-label="menu"
                onClick={toggleMenu}
              >
                <MenuIcon className="custom-menu-icon" />
              </IconButton>
            </div>
          </div>

          {menuOpen && (
            <div className="dropdown-content">
              <div
                className="hero-title"
                style={{
                  fontWeight: 800,
                  textTransform: 'uppercase',
                  letterSpacing: '0.06em',
                  fontSize: '0.95rem',
                  padding: 0,
                  marginBottom: '0.45rem',
                  display: 'block',
                  pointerEvents: 'none'
                }}
              >
                Pages
              </div>

              <div
                style={{
                  width: '100%',
                  borderTop: '2px solid currentColor',
                  marginBottom: '0.75rem'
                }}
              />

              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '0.6rem'
                }}
              >
                {navItems.map((item) => (
                  <NavLink
                    key={item.name}
                    to={item.path}
                    className="navigation-link"
                    style={location.pathname === item.path ? activeStyle : {}}
                    onClick={handleNavLinkClick}
                  >
                    {item.name}
                  </NavLink>
                ))}
              </div>

              <div style={{ height: '1rem' }} />

              <div
                className="hero-title"
                style={{
                  fontWeight: 800,
                  textTransform: 'uppercase',
                  letterSpacing: '0.06em',
                  fontSize: '0.95rem',
                  padding: 0,
                  marginBottom: '0.45rem',
                  display: 'block',
                  pointerEvents: 'none'
                }}
              >
                Color Theme
              </div>

              <div
                style={{
                  width: '100%',
                  borderTop: '2px solid currentColor',
                  marginBottom: '0.75rem'
                }}
              />

              <ReactSelectSwitcher />
            </div>
          )}
        </div>
      </div>

      <div
        className="navigation"
        style={{
          position: 'absolute',
          left: '50%',
          top: '50%',
          transform: 'translate(-50%, -50%)'
        }}
      >
        <img
          src="/me4.png"
          alt="Mohamed Ibrahim"
          style={{
            height: '72px',
            width: '72px',
            objectFit: 'cover',
            borderRadius: '50%'
          }}
        />
      </div>

      <div className="right-section">
        <ThemeSwitcher />
      </div>
    </header>
  );
};

export default Header;
